import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

export const UPDATE_PAYROLL_CALCULATION = addAuthVars(gql`
  mutation updatePayrollCalculation(
    $id: ID!
    $name: String!
    $config: [JSONObject]!
  ) {
    updatePayrollCalculation(id: $id, name: $name, config: $config) {
      id
      name
      config
    }
  }
`);

export const useUpdatePayrollCalculation = () => {
  const [update, { loading, error }] = useMutation(UPDATE_PAYROLL_CALCULATION, {
    onError: error => {
      throw error;
    }
  });
  const updatePayrollCalculation = async ({
    id,
    name,
    config
  }: {
    id: string;
    name: string;
    config: JSON;
  }) => {
    await update({
      variables: {
        id,
        name,
        config
      },
      refetchQueries: ["payrollCalculations"]
    });
  };

  return { updatePayrollCalculation, loading, error };
};
